import { useState, useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import axios from "axios";

// Static-site deployment: the PHP handler sits next to index.html.
// In dev (yarn start) we point to the local backend or just disable.
const ENQUIRY_ENDPOINT = "/enquiry.php";

const INITIAL = {
  name: "",
  email: "",
  phone: "",
  company: "",
  product_interest: "",
  message: "",
  website: "", // honeypot — must stay empty
};

export default function useEnquiryForm() {
  const [searchParams] = useSearchParams();
  const prefilledProduct = searchParams.get("product") || "";

  const [form, setForm] = useState({ ...INITIAL, product_interest: prefilledProduct });
  const [status, setStatus] = useState({ state: "idle", error: "" });

  useEffect(() => {
    if (prefilledProduct) {
      setForm((f) => ({ ...f, product_interest: prefilledProduct }));
    }
  }, [prefilledProduct]);

  const onChange = (e) =>
    setForm((f) => ({ ...f, [e.target.name]: e.target.value }));

  const reset = () => {
    setForm({ ...INITIAL, product_interest: prefilledProduct });
    setStatus({ state: "idle", error: "" });
  };

  const onSubmit = async (e) => {
    e.preventDefault();
    setStatus({ state: "loading", error: "" });
    try {
      const res = await axios.post(ENQUIRY_ENDPOINT, form, {
        headers: { "Content-Type": "application/json" },
        timeout: 20000,
      });
      if (res.data && res.data.ok) {
        setStatus({ state: "success", error: "" });
        setForm({ ...INITIAL, product_interest: prefilledProduct });
      } else {
        setStatus({
          state: "error",
          error: (res.data && res.data.error) || "We couldn't send your enquiry. Please email sales@ceaindia.in directly.",
        });
      }
    } catch (err) {
      const serverMsg = err?.response?.data?.error;
      setStatus({
        state: "error",
        error:
          serverMsg ||
          "We couldn't send your enquiry right now. Please try again, or email sales@ceaindia.in directly.",
      });
    }
  };

  return { form, status, onChange, onSubmit, reset, prefilledProduct };
}
